<template>
  <div :class="bem()">
    <slot></slot>
  </div>
</template>

<script>
import { Index } from 'vue-instantsearch'
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('searchEnginePage')
export default {
  extends: Index,
  computed: {
  },
  methods: {
    ...mapMutations(['setCheckedPools'])
  },
  watch: {
    '$route' () {
      // clear refinements
      this._localSearchStore.query = ''
      this._localSearchStore.clearRefinements()

      this.setCheckedPools({})

      this._localSearchStore.indexName = this.indexName
    }
  }
}
</script>
